import '@mdi/font/css/materialdesignicons.css';
import { createVuetify } from 'vuetify';
import { VDateInput } from 'vuetify/labs/VDateInput';
import 'vuetify/styles';
import { ja } from 'vuetify/locale';

export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    // SSR用の設定を追加
    ssr: true,
    theme: {
      defaultTheme: 'light',
      themes: {
        light: {
          colors: {
            primary: '#367193',
            secondary: '#1976D2',
            danger: '#CB1414',
            warning: '#A97B02',
            secondaryBk: '#707070',
            error: '#CB1414',
            required: '#BF360C',
          },
        },
      },
    },
    components: {
      VDateInput,
    },
    locale: {
      locale: 'ja',
      messages: {
        ja: ja,
      },
    },
  });

  nuxtApp.vueApp.use(vuetify);
});
